import welcome from './welcome';

const posts = [welcome];

export default posts;
